import { createApiHook, useApi } from "../utils/apiUtils";

const useDeleteAnswerType = () => {
  const { apiDelete } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const deleteAnswerType = async (id) => {
    startLoading();
    const res = await apiDelete(`/answer_types/${id}`, "Error al eliminar el tipo de respuesta");
    setResponse(res);
    if (res?.error) {
      const err = new Error(res.error.message || "No se pudo eliminar el tipo de respuesta");
      err.backend = res.error;
      throw err;
    }
    return res;
  };

  return { deleteAnswerType, data, loading, error };
};

export default useDeleteAnswerType;
